import React from 'react';

interface MarqueeProps {
  children: React.ReactNode;
  direction?: 'left' | 'right' | 'up' | 'down';
  speed?: number;
  className?: string;
  style?: React.CSSProperties;
}

const Marquee: React.FC<MarqueeProps> = ({ 
  children, 
  direction = 'left', 
  speed = 50, 
  className = '',
  style = {}
}) => {
  // Calculate duration based on speed (1-100, where 100 is fastest)
  // Speed 1 = 50s, Speed 100 = 5s
  const duration = 50 - (speed - 1) * 0.45;
  
  const animations = {
    left: 'marquee-left',
    right: 'marquee-right',
    up: 'marquee-up',
    down: 'marquee-down'
  };

  const animationName = animations[direction] || animations.left;
  const isVertical = direction === 'up' || direction === 'down';

  return (
    <div 
      className={`overflow-hidden ${className}`}
      style={{
        ...style,
        width: '100%',
        height: '100%',
        position: 'relative',
      }}
    >
      <div
        style={{
          display: isVertical ? 'block' : 'inline-flex',
          animation: `${animationName} ${duration}s linear infinite`,
          whiteSpace: isVertical ? 'normal' : 'nowrap',
          padding: isVertical ? '20px 0' : '0 50px',
          margin: 0,
          width: isVertical ? '100%' : 'auto',
          minWidth: isVertical ? '100%' : 'auto',
          alignItems: 'center',
        }}
      >
        {children}
      </div>
      <style>{`
        @keyframes marquee-left {
          0% { transform: translateX(0%); }
          100% { transform: translateX(-100%); }
        }
        @keyframes marquee-right {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(0%); }
        }
        @keyframes marquee-up {
          0% { transform: translateY(0%); }
          100% { transform: translateY(-100%); }
        }
        @keyframes marquee-down {
          0% { transform: translateY(-100%); }
          100% { transform: translateY(0%); }
        }
      `}</style>
    </div>
  );
};

export default Marquee;
